/**
 * Notification display component
 */
import { useEffect } from 'react';
import { INotif, NotifKind } from '../../reducers/notifications';

import ErrorIcon from './images/error.svg';
import SuccessIcon from './images/success.svg';
import InfoIcon from './images/info.svg';
import LearnIcon from './images/learn.svg';
import WarningIcon from './images/warning.svg';

import './styles.scss';

const mapping: Record<NotifKind, string> = {
  error: ErrorIcon,
  success: SuccessIcon,
  info: InfoIcon,
  learn: LearnIcon,
  warning: WarningIcon,
};

const colorsMapping: Record<NotifKind, string> = {
  error: '#FD7474',
  success: '#89EDAB',
  info: '#7990EC',
  learn: '#A56EF7',
  warning: '#F79C6E',
};

const CloseIcon = ({ color }: any) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 14L14 6'
      stroke={color}
      strokeWidth='1.2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14 14L6 6'
      stroke={color}
      strokeWidth='1.2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

interface INotificationProps {
  data: INotif;
  onClose(): void;
}

const Notification = ({ data, onClose }: INotificationProps) => {
  useEffect(() => {
    const timer = window.setTimeout(onClose, data.dismissAfter);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className={`notification notification--${data.kind}`}>
      <img
        className='notification__icon'
        src={mapping[data.kind]}
        alt={`${data.kind} icon`}
      />
      {data.title && <div className='notification__title'>{data.title}</div>}
      <div className='notification__text' title={data.message.toString()}>
        {data.message}
      </div>
      <div className='notification__close text--clickable' onClick={onClose}>
        <CloseIcon color={colorsMapping[data.kind]} />
      </div>
    </div>
  );
};

export default Notification;
